/* Delivery rules verified 2026-10-09. No description scanning or network calls.
 * Colissimo: laposte.fr/fiche-destination/envoi-colis/{islande,norvege,maroc}
 * Rules here are a snapshot, not an automatic Shopify shipping-rate sync. */
(() => {
  if (customElements.get('si-delivery-estimate')) return;
  const DAY = 86400000;
  const date = (y,m,d) => new Date(Date.UTC(y,m-1,d));
  const plus = (d,n) => new Date(d.getTime()+n*DAY);
  const key = d => d.toISOString().slice(0,10);
  const holidayCache = new Map();
  function holidays(year) {
    if (holidayCache.has(year)) return holidayCache.get(year);
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,
      f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,
      i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
      month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    const easter=date(year,month,day);
    const days=new Set(['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'].map(x=>`${year}-${x}`));
    [1,39,50].forEach(n=>days.add(key(plus(easter,n))));
    holidayCache.set(year,days); return days;
  }
  const working = (d,saturday=false) => d.getUTCDay()!==0 && (saturday || d.getUTCDay()!==6) && !holidays(d.getUTCFullYear()).has(key(d));
  function nextWorking(d,saturday=false) { while(!working(d,saturday)) d=plus(d,1); return d; }
  function transit(d,count,saturday=false) { while(count>0){d=plus(d,1);if(working(d,saturday))count--;}return d; }
  function dispatch(now) {
    const p=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(x=>[x.type,x.value]));
    let d=date(+p.year,+p.month,+p.day);
    if (+p.hour>=15) d=plus(d,1);
    return nextWorking(d);
  }
  const locale=document.documentElement.lang||'en';
  const fmt=d=>new Intl.DateTimeFormat(locale,{weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(d);
  const range=(a,b)=>key(a)===key(b)?fmt(a):`${fmt(a)} – ${fmt(b)}`;
  const region=code=>new Intl.DisplayNames([locale],{type:'region'}).of(code);
  const europe=new Set('AT BE DE IT LU NL PL PT ES BG HR CZ DK EE FI GR HU IE LV LT RO SK SI SE'.split(' '));
  const relay=new Set('AT BE DE IT LU NL PL PT ES'.split(' '));
  function methods(country,ship,t) {
    const normal=(label,min,max,saturday=true,detail='')=>({label,when:range(transit(ship,min,saturday),transit(ship,max,saturday)),detail:detail||t(saturday?'transit_sat':'transit_week',{min,max})});
    if(country==='FR') {
      const earliest=nextWorking(plus(ship,1),true);
      const latest=ship.getUTCDay()===5?nextWorking(plus(ship,3)):earliest;
      return [{label:'Chronopost',when:range(earliest,latest),detail:t('chronopost_note')},normal(t('standard'),2,5,true),normal('Mondial Relay',3,5),normal(t('economy'),4,12)];
    }
    if(europe.has(country))return [normal(relay.has(country)?'Colissimo Europe':t('europe'),3,5,true),...(relay.has(country)?[normal('Mondial Relay',3,5)]:[]),normal(t('economy'),4,12)];
    const special={IS:[`Colissimo ${region('IS')}`,4,5,true],NO:[`Colissimo ${region('NO')}`,6,7,true],MA:[`Colissimo ${region('MA')}`,4,7,true],GB:['FedEx Regional Economy',3,5,true],CH:[t('standard'),3,5,true],US:['FedEx International Economy',5,10,true],GP:[`Colissimo ${region('GP')}`,5,7,true]};
    return special[country]?[normal(...special[country])]:[];
  }
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.messages=JSON.parse(this.querySelector('[data-delivery-i18n]').textContent);
      this.t=(key,params={})=>Object.entries(params).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',String(v)),this.messages[key]||'');
      this.variants=JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
      this.form=document.getElementById(this.dataset.form);
      this.country=this.dataset.country;
      this.onChange=()=>this.render();
      this.form?.addEventListener('change',this.onChange);
      this.selector=this.querySelector('[data-delivery-country]');
      this.onCountry=()=>{this.country=this.selector.value;this.render();};
      this.selector.addEventListener('change',this.onCountry);
      this.onVisible=()=>{if(!document.hidden)this.render();};
      document.addEventListener('visibilitychange',this.onVisible);
      this.timer=setInterval(()=>this.render(),60000);
      this.render();
    }
    disconnectedCallback(){clearInterval(this.timer);this.form?.removeEventListener('change',this.onChange);this.selector?.removeEventListener('change',this.onCountry);document.removeEventListener('visibilitychange',this.onVisible);}
    render() {
      const input=this.form?.querySelector('[name="id"]');
      const variant=input?input.value:this.dataset.variant;
      this.hidden=this.variants[variant]!==true;
      if(this.hidden)return;
      const ship=dispatch(new Date()),list=methods(this.country,ship,this.t);
      const title=this.querySelector('[data-delivery-title]');
      title.replaceChildren();
      if(list.length){
        title.append(document.createTextNode(`${this.t('estimated')} ${list[0].label} : `));
        const span=document.createElement('span');span.className='si-delivery__date';span.textContent=list[0].when;title.append(span);
      }else title.textContent=this.t('checkout_options');
      this.querySelector('[data-delivery-dispatch]').textContent=list.length?this.t('dispatch',{date:fmt(ship)}):this.t('checkout_options');
      this.querySelector('[data-delivery-service]').textContent=list[0]?.detail||'';
      const options=this.querySelector('[data-delivery-options]'); options.replaceChildren();
      list.forEach(method=>{const row=document.createElement('div');row.className='si-delivery__option';const name=document.createElement('strong'),value=document.createElement('span');name.textContent=method.label;value.append(document.createTextNode(this.t('estimated')+' : '));const span=document.createElement('span');span.className='si-delivery__date';span.textContent=method.when;value.append(span,document.createTextNode('. '+method.detail));row.append(name,value);options.append(row);});
      this.querySelector('[data-delivery-note]').textContent=this.t(['IS','NO','MA','GB','CH','US','GP'].includes(this.country)?'customs_note':'cutoff_note');
    }
  }
  customElements.define('si-delivery-estimate',DeliveryEstimate);
})();

